// Ringy-style quick alert toggles shown in the profile menu. State lives in
// Agent.notifications.{masterSwitch,smsAlerts,callAlerts,leadAlerts}.

/** @typedef {'masterSwitch'|'smsAlerts'|'callAlerts'|'leadAlerts'} AlertKey */

/** @type {Array<{key: AlertKey, label: string, hint: string}>} */
export const ALERT_TOGGLES = [
  { key: 'masterSwitch', label: 'MASTER SWITCH', hint: 'Turns every alert below on or off at once.' },
  { key: 'smsAlerts', label: 'SMS ALERTS', hint: 'Text your phone when one of your CIVIX numbers gets an inbound text.' },
  { key: 'callAlerts', label: 'CALL ALERTS', hint: 'Text your phone when an inbound call arrives.' },
  { key: 'leadAlerts', label: 'LEAD ALERTS', hint: 'Text your phone each time a new lead lands in your account.' },
];

// Mirrors the API defaults (agentAlertGate.js) for agents saved before the fields existed.
const DEFAULTS = { masterSwitch: true, smsAlerts: false, callAlerts: false, leadAlerts: true };

/**
 * @param {object|null|undefined} notifications Agent.notifications (may be partial).
 * @returns {Record<AlertKey, boolean>} Every toggle resolved to a boolean.
 */
export function resolveAlertState(notifications) {
  const n = notifications || {};
  const out = {};
  for (const k of Object.keys(DEFAULTS)) out[k] = typeof n[k] === 'boolean' ? n[k] : DEFAULTS[k];
  return /** @type {Record<AlertKey, boolean>} */ (out);
}

/**
 * @param {string} label
 * @param {boolean} on
 * @returns {string} e.g. "SMS ALERTS - ON".
 */
export const toggleText = (label, on) => `${label} - ${on ? 'ON' : 'OFF'}`;

/**
 * @param {{name?: string, firstName?: string}|null|undefined} agent
 * @returns {string} First name for the "Welcome, …" header.
 */
export function firstNameOf(agent) {
  return String(agent?.firstName || agent?.name || '').trim().split(/\s+/)[0] || '';
}
